module.exports = __webpack_public_path__ + "img/wave-pulse.869abf14.svg";